import React from "react";
import { Box, Container } from "@mui/material";
import Card from "../Card/Card";
import Cocacola from "../../assets/images/cocacola.svg";
import Google from "../../assets/images/google.svg";
import Amazon from "../../assets/images/amazonsvg.png";
import Thetimesofindia from "../../assets/images/theTimesofindia.svg";
import Hunkidori from "../../assets/images/hunkidori.png";


function Brand() {

  const customImageWidth = {
    xs: "65%", // Reduced from 65%
    sm: "60%", // Reduced from 90%
    md: "85%", // Reduced from 85%
    lg: "80%", // Reduced from 80%
    xl: "85%", // Reduced from 70%
  };
  const customImageWidthSecond = {
    xs: "45%", // Reduced from 95%
    sm: "60%", // Reduced from 90%
    md: "85%", // Reduced from 85%
    lg: "110%", // Reduced from 80%
    xl: "110%", // Reduced from 100%
  };
  const customImageWidthThird = {
    xs: "100%", // Reduced from 95%
    sm: "60%", // Reduced from 90%
    md: "85%", // Reduced from 85%
    lg: "110%", // Reduced from 80%
    xl: "110%", // Reduced from 100%
  };
  const CardBody = (
    <>
      {[Cocacola, Google, Amazon, Thetimesofindia, Hunkidori].map(
        (image, index) => (
          <Box
            key={index}
            sx={{
              ...styles.boxImage,
              animation: `slideUp 0.5s ease-out ${index * 0.2}s both`,
              opacity: 0,
              "@keyframes slideUp": {
                "0%": {
                  transform: "translateY(50px)",
                  opacity: 0,
                },
                "100%": {
                  transform: "translateY(0)",
                  opacity: 1,
                },
              },
            }}
          >
            <Box
              key={index}
              component="img"
              src={image}
              alt={`Image ${index + 1}`}
              sx={{
                ...styles.image,
                width:
                  image === Thetimesofindia
                    ? customImageWidthThird
                    : image === Hunkidori
                    ? customImageWidthSecond
                    : customImageWidth,
              }}
            />
          </Box>
        )
      )}
    </>
  );

  return (
    <Box sx={styles.appBarStyle}>
    
      <Container maxWidth="xl" sx={styles.containerStyle}>
        <Card
          paddingTop={{
            xs: 0, // mobile
            sm: 1, // tablet
            md: 1.5, // desktop
            lg: 2, // large desktop
            xl: 4, // large desktop
          }}
          paddingBottom={{
            xs: 0, // mobile
            sm: 1, // tablet
            md: 1.5, // desktop
            lg: 2, // large desktop
            xl: 4, // large desktop
          }}
          paddingLeft={{
            xs: 2, // mobile
            sm: 3, // tablet
            md: 4, // desktop
            lg: 5, // large desktop
            xl: 6, // large desktop
          }}
          paddingRight={{
            xs: 2, // mobile
            sm: 3, // tablet
            md: 4, // desktop
            lg: 5, // large desktop
            xl: 6, // large desktop
          }}
          width={{
            xs: "97%", // mobile
            sm: "95%", // tablet
            md: "85%", // desktop
            lg: "75%", // large desktop
            xl: "68%", // large desktop
          }}
        >
          {CardBody}
        </Card>
      </Container>
    </Box>
  );
}

export default Brand;

const styles = {
  appBarStyle: {
    background:
      "linear-gradient(to bottom, #fff9e3 0%, #fff9e3  50%, #fff 50%, #fff 100%)",
  },
  coreFeatureTxt:{
    textAlign:"center",
    paddingTop: { 
      xs: 2,  // 16px for mobile
      sm: 3,  // 24px for tablet
      md: 4,  // 32px for desktop
      lg: 5,  // 40px for large desktop
      xl: 6   // 48px for extra large screens
    }
  },

  containerStyle: {
    width: "100%",
    paddingTop: { xs: 4, sm: 6, md: 8, lg: 10, xl: 10 },
    paddingBottom: { xs: 4, sm: 6, md: 8, lg: 10, xl: 10 },
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    background:
      "linear-gradient(to bottom, #fff9e3 0%, #fff9e3  50%, #fff 50%, #fff 100%)",
  },
  image: {
    height: "auto",
    maxWidth: "100%",
    objectFit: "contain",
    display: "block",
    margin: "auto",
  },
  boxImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: {
      xs: 1,
      sm: 2.5,
      md: 3,
      lg: 3.5,
      xl: 4,
    },
    flex: {
      xs: "0 0 50%",
      sm: "0 0 33.33%",
      md: "0 0 20%",
    },
    minHeight: {
      xs: "80px",
      sm: "90px",
      md: "100px",
      lg: "110px",
    },
    boxSizing: "border-box",
    "&:last-child": {
      "@media (max-width: 600px)": {
        flex: "0 0 100%",
        alignSelf: "center",
        justifyContent: "center",
        justifyItems: "center",
        display: "flex",
      },
    },
  },
};
